<template>
  <!-- 维护等级 -->
  <el-dialog
    :title="title"
    :visible.sync="supplierGradeDiaShow"
    width="73%"
    :before-close="beforeClose"
  >
    <!--     列表-->
    <div class="multifunctional-table-wrapper-tree">
      <div class="multifunctional-table-wrapper">
        <el-table
          :data="tableDataUpdate"
          row-key="index"
          border
          max-height="450"
          class="multifunctional-table"
        >
          <el-table-column label="序号" width="70">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="供应商分类"
            width="180"
            prop="supplierTypeName"
          >
            {{ supplierTypeNameArr[supplierTypeCode] }}
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="gradeType"
            label="等级类型"
            width="180"
          >
            <template slot-scope="scope">
              {{
                scope.row.gradeType == "0"
                  ? "合格"
                  : scope.row.gradeType == "1"
                  ? "不合格"
                  : scope.row.gradeType == "2"
                  ? "未评级"
                  : "合格"
              }}
            </template>
          </el-table-column>
          <el-table-column label="等级名称">
            <template slot-scope="scope">
              <input
                class="requireFileInput"
                type="text"
                v-model="scope.row.gradeName"
                :placeholder="scope.row.placeholder"
                :maxlength="maxLen"
                ref="gradeNameInput"
              />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <el-button
                :disabled="scope.$index < 2"
                v-if="true"
                size="mini"
                type="text"
                @click="handleGoAdd(scope.$index, scope.row)"
                >添加
              </el-button>
              <el-button
                :disabled="scope.$index < 3"
                v-if="true"
                size="mini"
                type="text"
                @click="handleGoDelete(scope.$index, scope.row)"
                >删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div size="mini" type="default-mini" slot="footer" class="dialog-footer">
      <el-button size="mini" type="default-mini" @click="dialogCancelHandle"
        >取消</el-button
      >
      <el-button size="mini" type="primary-font-mini" @click="dialogSureHandle"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { maintainGrade, checkDeleteRank } from "../api/appSet.js";

export default {
  name: "baseOpera-supplierGradeDia",
  props: ["supplierTypeCode", "gradeList"],
  data() {
    return {
      title: "维护等级",
      isFocus: 1,
      supplierGradeDiaShow: true,
      tableData: [],
      tableDataUpdate: [],
      aptitudeName: "",
      placeholder: "",
      maxLen: 10,
      delId: [],
      deleteIds: [],
      supplierTypeNameArr: { A: "工程类", B: "物资类", C: "服务类" }
    };
  },

  mounted() {
    this.getGradeList();
  },

  methods: {
    indexMethod(index) {
      return index + 1;
    },
    // click any
    beforeClose() {
      this.supplierGradeDiaShow = false;
      this.$emit("gradeDialogCancel", this.supplierGradeDiaShow);
    },
    getGradeList() {
      console.log(this.gradeList);
      if (this.gradeList && this.gradeList.length > 0) {
        this.tableDataUpdate = JSON.parse(JSON.stringify(this.gradeList));
      }
    },
    dialogCancelHandle() {
      this.supplierGradeDiaShow = false;
      this.$emit("gradeDialogCancel", this.supplierGradeDiaShow);
    },
    dialogSureHandle() {
      if (
        this.$refs["gradeNameInput"] &&
        this.$refs["gradeNameInput"].value == ""
      ) {
        this.$message({
          message: "请输入等级名称！",
          type: "warning",
          duration: 3000,
          ccuiCustom: true,
          showClose: true,
          offset: document.body.clientHeight / 2 - 21
        });
        return;
      }
      // 维护等级接口
      const obj = {
        supplierGradeBOList: this.tableDataUpdate,
        deleteIds: this.deleteIds,
        isShowLoading: true,
        loadingMessage: "提交中,请稍等..."
      };
      maintainGrade(obj)
        .then(res => {
          // 将弹窗的数据发送给父页面
          this.supplierGradeDiaShow = false;
          this.$emit("gradeDialogSure", this.supplierGradeDiaShow);
        })
        .catch(err => {});
    },
    handleGoAdd() {
      // 添加一空行
      this.tableDataUpdate.push({
        supplierTypeName: this.supplierTypeNameArr[this.supplierTypeCode],
        supplierTypeCode: this.supplierTypeCode,
        gradeName: "",
        gradeType: "0",
        placeholder: "请输入等级名称"
      });
    },
    handleGoDelete(index, row) {
      console.log(row.id);
      if (row.id) {
        //如果点了添加又点了删除，实际没有真正的删除操作，Id为空或undefined
        const obj = { supplierRank: row.id };
        checkDeleteRank(obj).then(res => {
          //判断id是否已被组织使用，如使用不别删除
          console.log(res);
          this.tableDataUpdate.splice(index, 1);
          this.deleteIds.push(row.id);
        });
      } else {
        this.tableDataUpdate.splice(index, 1);
      }
    }
  }
};
</script>

<style scoped lang="scss">
/deep/ .el-dialog__body {
  padding: 0 20px 20px;
  overflow: hidden !important;
}

/deep/ .el-dialog__title {
  font-size: 14px;
  font-weight: 600;
}

/deep/ .el-dialog__header {
  margin-bottom: 20px;
}
.requireFileInput {
  width: 288px;
  height: 22px;
  background: #f1f1f1;
  border: none;
  border-radius: 4px;
  color: #4a4a4a;
  font-size: 13px;
  padding: 0 4px;
  line-height: 22px;
}
/deep/
  .multifunctional-table-wrapper
  .el-table__fixed-right
  .el-table__fixed-body-wrapper
  .el-table__body
  tbody
  .el-table__row
  td
  .cell
  .el-button
  span {
  color: #0089ef;
}
/deep/
  .multifunctional-table-wrapper
  .el-table__fixed-right
  .el-table__fixed-body-wrapper
  .el-table__body
  tbody
  .el-table__row
  td
  .cell
  .el-button.is-disabled
  span {
  color: #999;
}
</style>
